import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { SupplierNotes } from "../../../api";

export const supplierNotesKeys = {
  supplierNotes: () => ["supplierNotes"]
};

export function useGetSupplierNotes(paramsString, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierNotesKeys.supplierNotes(), paramsString],
    () => callApi(SupplierNotes.getSupplierNotes, paramsString), config);
}

export function useCreateSupplierNotes(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(SupplierNotes.createSupplierNotes, data), config);
}

export function useUpdateSupplierNotes(config) {
  const { callApi } = useAuth();
  return useMutation(({ id, data }) => callApi(SupplierNotes.updateSupplierNotes, { id, data }), config);
}

export function useDeleteSupplierNotes(config) {
  const { callApi } = useAuth();
  return useMutation(id => callApi(SupplierNotes.deleteSupplierNotes, id), config);
}
